(function () {
  const slideUp = (element, duration = 300) => {
    if (!element) return;

    // Ensure hidden panels can animate up from current height
    element.removeAttribute("hidden");
    element.setAttribute("aria-hidden", "false");

    element.style.height = `${element.scrollHeight}px`;
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = "0";
    });

    setTimeout(() => {
      // SEO-friendly: keep content in DOM, just hide via [hidden]
      element.style.removeProperty("display"); // don't force display:none
      element.setAttribute("hidden", "");
      element.setAttribute("aria-hidden", "true");

      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
    }, duration);
  };

  const slideDown = (element, duration = 300) => {
    if (!element) return;

    // SEO-friendly: show via removing [hidden]
    element.removeAttribute("hidden");
    element.setAttribute("aria-hidden", "false");

    // Ensure it's measurable
    element.style.removeProperty("display");
    let display = window.getComputedStyle(element).display;
    if (display === "none") display = "block";
    element.style.display = display;

    const height = element.scrollHeight;

    element.style.height = "0";
    element.style.overflow = "hidden";
    element.style.transition = `height ${duration}ms ease`;

    requestAnimationFrame(() => {
      element.style.height = `${height}px`;
    });

    setTimeout(() => {
      element.style.removeProperty("height");
      element.style.removeProperty("overflow");
      element.style.removeProperty("transition");
      // Let CSS/layout decide display, do not hardcode "block"
      element.style.removeProperty("display");
    }, duration);
  };

  const setButtonState = (item, expanded) => {
    if (!item) return;
    const btn = item.querySelector(".collapsible-content__toggle");
    const answer = item.querySelector(".collapsible-content__answer");
    if (btn) btn.setAttribute("aria-expanded", expanded ? "true" : "false");
    if (answer) answer.setAttribute("aria-hidden", expanded ? "false" : "true");
  };

  const toggleCollapsible = (event, toggles) => {
    if (!toggles) return;

    const item = event.currentTarget;
    const answer = item.querySelector(".collapsible-content__answer");
    const activeItem = Array.from(toggles).find((el) =>
      el.classList.contains("active")
    );

    // Open clicked item (and close any other open item)
    if (item !== activeItem) {
      if (activeItem) {
        activeItem.classList.remove("active");
        const activeAnswer = activeItem.querySelector(
          ".collapsible-content__answer"
        );
        setButtonState(activeItem, false);
        if (activeAnswer) slideUp(activeAnswer);
      }

      item.classList.add("active");
      setButtonState(item, true);
      if (answer) slideDown(answer);
    } else {
      // Close clicked item
      item.classList.remove("active");
      setButtonState(item, false);
      if (answer) slideUp(answer);
    }
  };

  const initCollapsibleContent = (section) => {
    if (!section || !section.classList.contains("collapsible-content-section")) {
      return;
    }

    const items = section.querySelectorAll(".collapsible-content__item");

    // Initial state sync (critical when using [hidden])
    items.forEach((item) => {
      const btn = item.querySelector(".collapsible-content__toggle");
      const answer = item.querySelector(".collapsible-content__answer");
      const isOpen = item.classList.contains("active");

      if (btn) btn.setAttribute("aria-expanded", isOpen ? "true" : "false");

      if (answer) {
        if (isOpen) {
          answer.removeAttribute("hidden");
          answer.setAttribute("aria-hidden", "false");
        } else {
          answer.setAttribute("hidden", "");
          answer.setAttribute("aria-hidden", "true");
        }
      }
    });

    // Only toggle when clicking the ITEM, but ignore clicks on links inside answers
    items.forEach((item) =>
      item.addEventListener("click", (event) => {
        const isLinkClick = event.target.closest("a, button:not(.collapsible-content__toggle)");
        if (isLinkClick) return;
        toggleCollapsible(event, items);
      })
    );

    section.querySelectorAll(".collapsible-content__show--more").forEach((button) => {
      button.addEventListener("click", () => {
        const parentItem = button.closest(".collapsible-content__content");
        const opacityItems = parentItem.querySelectorAll(".collapsible-content__item--opacity");
        const hiddenItems = parentItem.querySelectorAll(".collapsible-content__item--hidden");

        opacityItems.forEach((el) => el.classList.remove("collapsible-content__item--opacity"));
        hiddenItems.forEach((el) => el.classList.remove("collapsible-content__item--hidden"));

        button.classList.add("collapsible-content__show--hidden");
        const buttonLess = button.nextElementSibling;
        if (buttonLess) buttonLess.classList.remove("collapsible-content__show--hidden");
      });
    });

    section.querySelectorAll(".collapsible-content__show--less").forEach((button) => {
      button.addEventListener("click", () => {
        const parentItem = button.closest(".collapsible-content__content");
        const allItems = parentItem.querySelectorAll(".collapsible-content__item");

        if (allItems[3]) allItems[3].classList.add("collapsible-content__item--opacity");
        Array.from(allItems)
          .slice(4)
          .forEach((el) => el.classList.add("collapsible-content__item--hidden"));

        button.classList.add("collapsible-content__show--hidden");
        const buttonMore = button.previousElementSibling;
        if (buttonMore) buttonMore.classList.remove("collapsible-content__show--hidden");
      });
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    initCollapsibleContent(document.currentScript.parentElement);
  });

  if (!window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      initCollapsibleContent(event.target);
    });
  }
})();
